module.exports = __webpack_public_path__ + "img/hulve.7d032091.png";